import * as codec from './codec.js'

var encoding = {
  chars: '0123456789ABCDEF',
  bits: 4
}

export function parse (string, opts) {
  return codec.parse(string.toUpperCase(), encoding, opts)
}

export function stringify (data, opts) {
  return codec.stringify(data, encoding, opts)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/disklet/node_modules/rfc4648/lib/base16.js
// module id = 1087
// module chunks = 146